module.exports = __webpack_public_path__ + "static/img/block04.a1ebf451.png";